import {
  ThematicPackageBudgetTierResponse,
  ThematicPackageCustomBudgetResponse,
} from '@features/campaigns/shared/types/campaignSubmit.ts';
import { isKnownBudgetTier } from '@features/campaigns/thematicPackage/utils/isKnownBudgetTier.ts';

// Not the API's custom minimum: a custom amount is floored at the highest tier, never the cheapest.
export function resolveLowestBudgetAmount(
  budgetTiers: ThematicPackageBudgetTierResponse[] = [],
  customBudget?: ThematicPackageCustomBudgetResponse,
): number {
  const presetAmounts = budgetTiers.filter(isKnownBudgetTier).map(({ amount }) => amount);

  if (presetAmounts.length === 0) {
    return customBudget?.minimumAmount ?? 0;
  }

  return Math.min(...presetAmounts);
}
